<script lang="ts">
  import { storeHeroMenu } from "$lib/js/stores";
  import { t } from 'svelte-i18n-lingui';

  function openMenu() {
    $storeHeroMenu = 'categories';
  }

  $: innerWidth = 0;
</script>


<svelte:window bind:innerWidth />

{#if innerWidth > 1024}
  <button class="cats-btn" on:mouseenter={() => openMenu()}>
    <span class="icon icon-categories"></span>
    {$t`Categories`}
  </button>
{:else if innerWidth > 768}
  <button class="cats-btn" on:click="{() => openMenu()}">
    <span class="icon icon-categories"></span>
    {$t`Categories`}
  </button>
{/if}


<style lang="scss">
  .cats-btn {
    transition: all linear 0.125s;
    font-size: 16px;
    font-weight: 700;
    padding-right: 20px;
    margin-left: 15px;
    padding-bottom: 11px;

    @media (min-width: 769px) {
      margin-top: 4px;
    }

    .icon {
      display: inline-block;
      transform: scaleX(-1);
      font-size: 13px;
      margin-right: 8px;
    }
  }
</style>